Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramMediaContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.InstagramMediaContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    return socialContent.group_type == 'instagramapi' and socialContent.data and socialContent.data.type == 'instagramMedia'
